import axios from 'config/axiosConfig'
import { definitions, reading_assessment, assessments, admin_assessments } from 'keys/apis'
import { MiniWordRM } from 'models/RM'
import { updateType } from 'keys'
import setFilters from 'config/filters'

export const getNestedWordsFetch = ({ id, signal }) => {
    if (id)
        return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${admin_assessments}${id}/get_words_nested/`)
}

export const getWordsFetch = async ({ id, signal }) => {
    if (id)
        return await axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}${id}/get_words/`, {
            signal
        })
}

export const getTrainingWordsFetch = async ({ id, signal }) => {
    if (id)
        return await axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}training_assessments/${id}/get_words/`, {
            signal
        })
}

export const getWordsVersionsFetch = async ({ id, signal }) => {
    if (id)
        return await axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}assessment_versions2/${id}/get_version_words/`, {
            signal
        })
}

export const getAnswersAndQuestionsFetch = async ({ id, signal }) => {
    return await axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}${id}/get_questions_and_answers/`, {
        signal
    })
}

export const getQuestionsFetch = async ({ id, signal }) => {
    if (id)
        return await axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}definitions/${id}/get_questions/`, {
            signal
        })
}

export const getWordDefsFrequencyFetch = async ({ page, pageSize, search, sorting, model }) => {
    let params = setFilters({ page, pageSize, search, sorting, model })
    return await axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}word_defs/get_word_defs_frequency/`, {
        params: params
    })
}

export const getIncorrectWordsFrequencyFetch = async ({ page, pageSize, search, sorting, model }) => {
    let params = setFilters({ page, pageSize, search, sorting, model })
    return await axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}words/get_incorrect_words_frequency/`, {
        params: params
    })
}

export const getWordDefsFetch = async ({ id, signal }) => {
    if (id)
        return await axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${definitions}${id}/get_word_defs/`, {
            signal
        })
}

export const saveWordsFetch = async ({ assessment, words, isTrainingAssessment }) => {
    let nWords = []
    let word_index = 1
    words.forEach((word, index) => {
        const typeDelete = word.update_type === updateType.delete

        nWords.push(
            new MiniWordRM({
                ...word,
                timePoint: assessment.timePoint,
                endPoint: assessment.endPoint,
                transcriptionStopPoint: assessment.transcriptionStopPoint
            }, word_index)
        )

        if (!typeDelete)
            word_index = word_index + 1
    });

    let url = `${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${admin_assessments}${assessment.id}/save_words/`
    if (isTrainingAssessment)
        url = `${process.env.REACT_APP_SERVER_PORT}${reading_assessment}training_admin_assessments/${assessment.id}/save_words/`

    await axios.post(url, {
        words: nWords
    })
    return nWords
}

export const saveWordFetch = ({ word, assessmentID }) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${admin_assessments}${assessmentID}/save_word_nested/`, {
        ...word
    })
}

export const deleteWordFetch = ({ assessmentID, wordID }) => {
    return axios.delete(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${admin_assessments}${assessmentID}/delete_word/`, {
        data: {
            word_id: wordID
        }
    })
}

export const getWordFetch = ({ wordID }) => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}words/${wordID}`)
}

export const deleteAssessmentWordsFetch = (assessmentID) => {
    return axios.delete(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${admin_assessments}${assessmentID}/delete_assessment_words/`, {
    })
}

